module.exports = __webpack_public_path__ + "static/img/ptd1.c07ecbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ptd/ptd1.png
// module id = 774
// module chunks = 0